import React from 'react';

import WaterUsageChart from './WaterUsageChart';
import CategoryLegend from './CategoryLegend';
import { categoricalColor } from './chartTheme';
import { chartData, reportChartKeys } from '../beforeAfter';

const frNumber = (value) => Math.round(value).toLocaleString('fr-FR');

/**
 * UN SCORE VENTILÉ, AVANT ET APRÈS L'ATELIER, côte à côte.
 *
 * Les calculs sont dans beforeAfter.js. `series` y est calculée par GraphGrid,
 * qui seul connaît le graphe précédent (la palette reprend là où il s'arrête).
 * Sans série, la carte le dit au lieu de rester vide : le validateur a déjà
 * refusé ce cas (`before_after_*`), il ne reste que les parties en cours pendant
 * une modification de l'atelier.
 *
 * Chaque anneau porte son propre `data-report-chart` : le rapport relève le
 * premier canvas d'un marqueur, et il en faut deux images ici.
 */
const BeforeAfterDoughnut = ({ series, scoreId }) => {
  if (!series) {
    return <p className="board-empty">Le score « {scoreId || '?'} » n'a rien à comparer.</p>;
  }

  const keys = reportChartKeys(series.scoreId);
  const values = Object.fromEntries(series.categories.map((row) => [row.label, row]));

  return (
    <div className="before-after">
      {series.name && <h3 className="board-card-title">{series.name}</h3>}
      {series.summary && <p className="board-card-hint">{series.summary}</p>}

      <div className="score-board-two-graphs">
        <div data-report-chart={keys.before}>
          <WaterUsageChart
            title="Avant l'atelier"
            data={chartData(series, 'before')}
            unit={series.unit}
            totalInitConsumption={series.scale}
            colorOffset={series.colorOffset}
          />
        </div>
        <div data-report-chart={keys.after}>
          <WaterUsageChart
            title="Après l'atelier"
            data={chartData(series, 'after')}
            unit={series.unit}
            totalInitConsumption={series.scale}
            colorOffset={series.colorOffset}
          />
        </div>
      </div>

      {/* Une légende pour les deux anneaux : ce sont les mêmes catégories, et
          un écran projeté ne se lit pas à l'infobulle. */}
      <CategoryLegend
        categories={series.categories.map((row) => row.label)}
        colorOf={(index) => categoricalColor(series.colorOffset + index)}
        values={values}
        unit={series.unit}
        formatValue={(row) => `${frNumber(row.before)} → ${frNumber(row.after)}`}
      />
    </div>
  );
};

export default BeforeAfterDoughnut;
